import apiEndPoints from "../../utils/apiEndPoints";
import { apiCall } from "../../utils/httpClient";

const getConfigurationSettingDetail = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.GETCONFIGURATIONSETTINGDETAIL,
    params
  );
  return data;
};
const updateSettingDetail = async (params) => {
  const data = await apiCall("post", apiEndPoints.UPDATESETTINGDETAIL, params);
  return data;
};
const getPrivacyPolicy = async (params) => {
  const data = await apiCall("post", apiEndPoints.GETPRIVACYPOLICY, params);
  return data;
};
const updatePrivacyPolicy = async (params) => {
  const data = await apiCall("post", apiEndPoints.UPDATEPRIVACYPOLICY, params);
  return data;
};

const configurationSettingService = {
  getConfigurationSettingDetail,
  updateSettingDetail,
  getPrivacyPolicy,
  updatePrivacyPolicy,
};

export default configurationSettingService;
